
import taskTable from '../submit-task/task-table.vue';
import { v2Host } from '@/config/host';
import qs from 'qs';

export default {
  components: {
    taskTable: taskTable
  },
  props: {
    tasks: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    demand: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      formConfig: {
        labelWidth: '110px',
        labelPosition: 'right'
      },
      formItemList: {
        worktime: {
          label: '工时消耗：',
          prop: 'worktime',
          type: 'plain-text'
        },
        estimated_time: {
          label: '预计完成日期：',
          prop: 'estimated_time',
          type: 'plain-text'
        },
        deliver_time: {
          label: '实际完成日期：',
          prop: 'deliver_time',
          type: 'plain-text'
        }
      },
      columnConfig: ['selection', 'platform', 'creation_types', 'channels', 'orientation', 'logo_position', 'close_time', 'category_id', 'status', 'action-cell'],
      selectTasks: []
    };
  },

  computed: {
    downloadUrl: function downloadUrl() {
      return v2Host + '/qa/task/download';
    }
  },
  methods: {
    handleSelectionChange: function handleSelectionChange(row) {
      this.selectTasks = row;
    },
    batchDownload: function batchDownload() {
      window.location.href = this.downloadUrl + '?' + qs.stringify({
        ids: this.selectTasks.map(function (item) {
          return item.submit_task_id;
        }).join()
      });
    }
  }
};